import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "title", "viewBox", "width", "height", "color"];
import React from 'react';
import { useTheme } from '../../styling';
import { SVGIconRoot } from './style';
export var SVGIcon = function SVGIcon(_ref) {
  var children = _ref.children,
      title = _ref.title,
      viewBox = _ref.viewBox,
      width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var fillColor = color || 'currentColor';
  var theme = useTheme();
  return React.createElement(SVGIconRoot, Object.assign({}, restProps, {
    viewBox: viewBox,
    focusable: "false",
    color: fillColor,
    iconWidth: width,
    iconHeight: height,
    theme: theme
  }), !!title && React.createElement("title", null, title), children);
};
export var SVGIconGroup = function SVGIconGroup(_ref2) {
  var children = _ref2.children;
  return React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, children);
};
export var SVGIconPath = function SVGIconPath(_ref3) {
  var d = _ref3.d;
  return React.createElement("path", {
    d: d,
    fill: "currentColor"
  });
};
SVGIcon.defaultProps = {
  display: 'inline-block',
  height: '1em',
  width: '1em',
  viewBox: '0 0 24 24'
};